import Skeleton from 'react-loading-skeleton';
import { ItemCardStyle } from '~/components/item-card/styles/item-card-style';

export const CardSkeleton = () => (
	<>
		{Array.from({ length: 4 }, (_, index) => (
			<ItemCardStyle key={index}>
				<div className="placeholder" aria-label="">
					<Skeleton height={179} />
				</div>
				<div className="equipment-content">
					<Skeleton height={20} width={200} />
					<Skeleton height={20} width={100} />
					<Skeleton height={20} width={100} />
				</div>
			</ItemCardStyle>
		))}
	</>
);
